module.exports = __webpack_public_path__ + "img/box-arrow-in-down-left.747e6090.svg";